import React from 'react';

import styled from 'styled-components';

import { Wordmark } from 'components/wordmark';

import { FooterLanguageSelector } from './footer-language-selector';
import { SocialIcons } from './social-icons';
import { IWordmarkAndSocialIcons as IWordmarkAndSocialIconsProps } from './types';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 1.125rem 0;

  :first-child {
    padding-top: 0.75rem;
  }

  :last-child {
    padding-bottom: 0;
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  > * + * {
    margin-left: 12px;
  }
`;

export const WordmarkAndSocialIcons: React.FC<IWordmarkAndSocialIconsProps> = ({
  socialIconsWidget,
}) => {
  const socialIconsProps = {
    instagramUrl: socialIconsWidget?.instagramUrl?.locale,
    facebookUrl: socialIconsWidget?.facebookUrl?.locale,
    youtubeUrl: socialIconsWidget?.youtubeUrl?.locale,
    twitterUrl: socialIconsWidget?.twitterUrl?.locale,
  };

  return (
    <Container>
      <Wordmark aria-hidden="true" />
      <SocialContainer>
        <FooterLanguageSelector />
        <SocialIcons {...socialIconsProps} />
      </SocialContainer>
    </Container>
  );
};
